/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ComapnyOfficeAddressBookCreateDto } from '../../models/comapny-office-address-book-create-dto';
import { EmptyResponse } from '../../models/empty-response';

export interface OfficeControllerCreateAddressBookOfanoffice$Params {
  id: number;
      body: ComapnyOfficeAddressBookCreateDto
}

export function officeControllerCreateAddressBookOfanoffice(http: HttpClient, rootUrl: string, params: OfficeControllerCreateAddressBookOfanoffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerCreateAddressBookOfanoffice.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

officeControllerCreateAddressBookOfanoffice.PATH = '/company/office/addressbook/office/{id}';
